var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticStyle:{"margin-top":"100px"}},[_vm._v("counter: "+_vm._s(_vm.getCounter))])])}
var staticRenderFns = []

export { render, staticRenderFns }